export default function getNextSelectAllState<T>(items: T[], getItemId: (item: T) => string, selection: string[]) {
    const itemIds = items.map(getItemId);

    const everyItemSelected = itemIds.every((itemId) => selection.includes(itemId));

    return everyItemSelected ? [] : itemIds;
}
